exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginButton{\r\n  width: 200px;\r\n  margin-top: 20px;\r\n  background-color: transparent;\r\n  border-color: aqua;\r\n  color: darkgray;\r\n}\r\n.loginButton:hover{\r\n  /*width: 200px;*/\r\n  /*margin-top: 20px;*/\r\n  /*background-color: transparent;*/\r\n  border-color: snow;\r\n  color: aqua !important;\r\n}\r\n.fa-google{\r\n  /*color: #1304043d;*/\r\n  /*color: aqua;*/\r\n  color: #df776f;\r\n  margin-right: 20px;\r\n  /*color: transparent;*/\r\n}\r\n.loginContainer{\r\n  margin: auto;\r\n  margin-top: 10%;\r\n}\r\n .logo-Container{\r\n   margin-top: 100px;\r\n }\r\n.tagline{\r\n  font-weight: 300;\r\n  font-size: 21px;\r\n  font-style: italic;\r\n  color: #c8c8c8;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main